import React, { ReactElement, ReactNode, useContext, useState } from 'react';
import SuggestedPaymentModal from '../../components/modals/SuggestedPaymentModal';
import AgedCreditCriteriaModal from '../../components/modals/AgedCreditCriteriaModal';
import { IWorkspaceAction } from '../../@types/workspaceTypes';
import { useHistory } from 'react-router';
import WorkspaceContext from '../../components/Context/WorkspaceContext';
import { useP4ToastController } from '../../views/system/NotificationsArea';
import { AlertType } from '../../graphql/schema/p4types';

enum SupplierWorkspaceAction {
  GlobalAmendments = 'SUPPLIERS_GLOBAL_AMENDMENTS',
  GenerateAgedCreditor = 'GENERATE_AGED_CREDITOR',
  SupplierSuggestPayment = 'SUPPLIER_SUGGEST_PAYMENT',
}

export const workspaceActionsForPermissions: Array<{ actionReference: SupplierWorkspaceAction }> = [
  {
    actionReference: SupplierWorkspaceAction.GlobalAmendments,
  },
  {
    actionReference: SupplierWorkspaceAction.GenerateAgedCreditor,
  },
  {
    actionReference: SupplierWorkspaceAction.SupplierSuggestPayment,
  },
];

export const useSupplierWorkspaceActions = (): [Array<IWorkspaceAction>, ReactNode | ReactElement] => {
  const workspace = useContext(WorkspaceContext);
  const [agedDebtCriteriaModalOpen, setAgedDebtCriteriaModalOpen] = useState(false);
  const [suggestedPaymentModalOpen, setSuggestedPaymentModalOpen] = useState(false);
  const history = useHistory();
  const { dispatchSimpleToast } = useP4ToastController();

  return [
    [
      {
        key: 'runGlobalAmendments',
        text: 'Run Global Amendments',
        onClick: () => {
          const selectionState = workspace.selectionState;
          if (selectionState && selectionState.count > 0) {
            dispatchSimpleToast('Run Global Amendments', `Preparing ${selectionState.count} records.`, AlertType.Info);
          }
          history.push({
            pathname: '/Suppliers/GlobalAmendments/New',
            state: { ...workspace.selectionState, previousLocation: history.location?.pathname || 'back' },
          });
        },
        permissionLabel: 'Global Amendments',
        actionReference: SupplierWorkspaceAction.GlobalAmendments,
      },
      {
        key: 'generatedAgedCreditor',
        text: 'Generate Aged Creditor',
        onClick: () => setAgedDebtCriteriaModalOpen(true),
        actionReference: SupplierWorkspaceAction.GenerateAgedCreditor,
      },
      {
        key: 'generatedSuggestedPayments',
        text: 'Generate Suggested Payments',
        onClick: () => setSuggestedPaymentModalOpen(true),
        permissionLabel: 'Suggested Supplier Payments',
        actionReference: SupplierWorkspaceAction.SupplierSuggestPayment,
      },
    ],
    <>
      <AgedCreditCriteriaModal isOpen={agedDebtCriteriaModalOpen} onClose={() => setAgedDebtCriteriaModalOpen(false)} />
      <SuggestedPaymentModal isOpen={suggestedPaymentModalOpen} onClose={() => setSuggestedPaymentModalOpen(false)} />
    </>,
  ];
};
